import { Link } from "react-router-dom";

// Footer links to the public policy pages
export function LegalLinks({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-4 ${className}`} data-testid="legal-links">
      <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy</Link>
      <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms</Link>
      <Link to="/security" data-testid="footer-security-link" className="hover:text-white">Security</Link>
    </span>
  );
}
